import styled from 'styled-components';
import {
  lighten,
} from 'polished';

import {
  Flex,
} from 'web-styled';

export const Folder = styled(Flex).attrs({
  align: 'center',
  spacing: 5,
  width: '100%',
})`
  color: ${props => props.theme.colors.link};
  background: transparent;

  cursor: pointer;
  user-select: none;

  ${props => props.isDisable && `
    color: #b3b3b3;
    background: #f9f9f9;
    & > span {
      cursor: not-allowed;
    }
  `};

  ${props => props.isSelected && `
    background: ${lighten(0.3, props.theme.colors.primary)};
  `};
`;
